import React from "react";

/**
 * A caption rendered the way WhatsApp shows it: line breaks and spacing kept
 * exactly (white-space: pre-wrap), *bold*, _italic_, ~strikethrough~ and
 * ```monospace``` applied, and links styled — so the Share to Broadcast
 * preview matches the message the groups receive.
 */
const TOKEN = /(```[\s\S]+?```|\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~|https?:\/\/[^\s]+)/g;

function renderLine(line, key) {
  const parts = [];
  let last = 0;
  line.replace(TOKEN, (match, _g, offset) => {
    if (offset > last) parts.push(line.slice(last, offset));
    const inner = match.slice(1, -1);
    if (match.startsWith("```")) parts.push(<code key={offset}>{match.slice(3, -3)}</code>);
    else if (match.startsWith("*")) parts.push(<strong key={offset}>{inner}</strong>);
    else if (match.startsWith("_")) parts.push(<em key={offset}>{inner}</em>);
    else if (match.startsWith("~")) parts.push(<s key={offset}>{inner}</s>);
    else parts.push(<span key={offset} className="wab-wa-link">{match}</span>);
    last = offset + match.length;
    return match;
  });
  if (last < line.length) parts.push(line.slice(last));
  return <React.Fragment key={key}>{parts}</React.Fragment>;
}

export function WhatsAppText({ text, className = "" }) {
  const lines = (text || "").split("\n");
  return (
    <div className={`wab-wa-text ${className}`.trim()}>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {renderLine(line, `l${i}`)}
          {i < lines.length - 1 ? "\n" : null}
        </React.Fragment>
      ))}
    </div>
  );
}

export default WhatsAppText;
